import EyeTestScreen from '@screens/vision/prescription/eyetest/EyeTest'

export default function PrescriptionEyetestPage() {
  return <EyeTestScreen />
}
